/* Will register additional offset to draw component */
import { Directive, OnInit, AfterViewInit, OnDestroy, ElementRef, HostBinding } from '@angular/core';

import { DrawCollapseService } from './draw-collapse.shared.service';

import { Subscription } from 'rxjs';
import { startWith, auditTime } from 'rxjs/operators';
@Directive({
    selector: '[directive-draw-offset-mobile]',
})
export class DrawOffsetMobileSharedDirective implements OnInit, AfterViewInit, OnDestroy {
    private _canAddOffset: boolean = true;
    private _elem: HTMLElement;
    private _height: number;

    private _drawIsCollapes: Subscription;

    @HostBinding('class.-draw-collapsed-mobile') public isCollapsed: boolean = true;

    constructor(
        private _drawCollapseService: DrawCollapseService,
        private _elementRef: ElementRef,
    ) { }

    ngOnInit(): void {
        this._elem = this._elementRef.nativeElement;

        const attr = this._elem.getAttribute('directive-draw-offset-mobile');
        if (attr === 'false') {
            this._canAddOffset = false;
        }
    }

    ngAfterViewInit(): void {
        this._drawIsCollapes = this._drawCollapseService.drawIsCollapsed$
            .pipe(
                auditTime(0),
            ).subscribe(isCollapsed => {
                this.isCollapsed = isCollapsed;
            });

        this._height = this._elem.clientHeight;

        if (!this._canAddOffset) return;
        this._drawCollapseService.addOffsetMobile(this._elem, this._height);
    }

    ngOnDestroy(): void {
        if (this._drawIsCollapes && !this._drawIsCollapes.closed) this._drawIsCollapes.unsubscribe();

        if (!this._canAddOffset) return;
        this._drawCollapseService.removeOffsetMobile(this._elem);
    }
}
